module.exports = __webpack_public_path__ + "static/media/fregadero.204afbad.svg";